export var ROUTER_PUSH = "ROUTER_PUSH";
export var ROUTER_GO_BACK = "ROUTER_GO_BACK";
export var ROUTER_REPLACE = "ROUTER_REPLACE";
export var GETTER_HOROSCOPE_TIME = "GETTER_HOROSCOPE_TIME";
export var UPDATE_HOROSCOPE = "UPDATE_HOROSCOPE";
export var GETTER_HOROSCOPE = "GETTER_HOROSCOPE";
export var UPDATE_TODAY_HOROSCOPE_FATE = "UPDATE_TODAY_HOROSCOPE_FATE";
export var GETTER_TODAY_HOROSCOPE_FATE = "GETTER_TODAY_HOROSCOPE_FATE";
export var UPDATE_TOMORROW_HOROSCOPE_FATE = "UPDATE_TOMORROW_HOROSCOPE_FATE";
export var GETTER_TOMORROW_HOROSCOPE_FATE = "GETTER_TOMORROW_HOROSCOPE_FATE";
export var UPDATE_WEEK_HOROSCOPE_FATE = "UPDATE_WEEK_HOROSCOPE_FATE";
export var GETTER_WEEK_HOROSCOPE_FATE = "GETTER_WEEK_HOROSCOPE_FATE";
export var UPDATE_MONTH_HOROSCOPE_FATE = "UPDATE_MONTH_HOROSCOPE_FATE";
export var GETTER_MONTH_HOROSCOPE_FATE = "GETTER_MONTH_HOROSCOPE_FATE";
export var UPDATE_YEAR_HOROSCOPE_FATE = "UPDATE_YEAR_HOROSCOPE_FATE";
export var GETTER_YEAR_HOROSCOPE_FATE = "GETTER_YEAR_HOROSCOPE_FATE";
export var GETTER_CURRENT_INS_USER_INFO = "GETTER_CURRENT_INS_USER_INFO";
export var TAKE_PHOTO = "TAKE_PHOTO";
export var TAKE_PHOTO_EX = "TAKE_PHOTO_EX";
export var CHECK_CAMERA_GUIDE = "CHECK_CAMERA_GUIDE";
export var AWS_INIT = "AWS_INIT"; //aws初始化

export var AWS_UPLOAD = "AWS_UPLOAD"; //aws上传图片

export var PRE_FACE_CHECK = "PRE_FACE_CHECK"; //预请求

export var PRE_FACE_DETECT = "PRE_FACE_DETECT"; //新脸部的检测

export var AGEING_FORECAST = "AGEING_FORECAST"; //变老相机

export var REQUEST_AGEING_FORECAST = "REQUEST_AGEING_FORECAST"; //变老相机 50-70-90

export var GENDER_SWITCH = "GENDER_SWITCH"; //职业转换

export var REQUEST_GENDER_SWITCH = "REQUEST_GENDER_SWITCH"; //职业转换 50-70-90

export var GET_CELEBRITES_PHOTOS = "GET_CELEBRITES_PHOTOS";
export var BEAUTY_CONTEST = "BEAUTY_CONTEST"; //比美

export var BEAUTY_CONTEST_SCANIG = "BEAUTY_CONTEST_SCANIG";
export var RATE_US = "RATE_US";
export var UPDATE_RATE_US_STATUS = "UPDATE_RATE_US_STATUS";
export var GETTER_RATE_US_STATUS = "GETTER_RATE_US_STATUS";
export var UPDATE_VIP_CLOSE_COUNT = "UPDATE_VIP_CLOSE_COUNT";
export var GETTER_VIP_CLOSE_COUNT = "GETTER_VIP_CLOSE_COUNT";
export var ETHNICITY_SCANNER = "ETHNICITY_SCANNER";
export var FUTURE_BABY = "FUTURE_BABY";
export var FUTURE_BABY_NEW = "FUTURE_BABY_NEW";
export var FUTURE_BABY_IOSNEW = "FUTURE_BABY_IOSNEW";
export var GET_FUTURE_BABY_RESULT = "GET_FUTURE_BABY_RESULT";
export var GET_FUTURE_BABY_RESULT_NEW = "GET_FUTURE_BABY_RESULT_NEW"; //payment

export var INIT_IAP = "INIT_IAP";
export var REGISTER_PRODUCT_ID = "REGISTER_PRODUCT_ID"; //注册product_id

export var PAY_BY_IAP = "PAY_BY_IAP"; //iap支付

export var PERSONAL_FUTRUE = "PERSONAL_FUTRUE";
export var INITIAL_SETTING = "INITIAL_SETTING";
export var INITIAL_LANGUAGE = "INITIAL_LANGUAGE";
export var UPDATE_PAYMENT_SWITCH_THRESHOLD = "UPDATE_PAYMENT_SWITCH_THRESHOLD";
export var GETTER_INIT_IAP_STATUS = "GETTER_INIT_IAP_STATUS";
export var UPDATE_INIT_IAP_STATUS = "UPDATE_INIT_IAP_STATUS";
export var CHECK_INIT_IAP_STATUS = "CHECK_INIT_IAP_STATUS";
export var GETTER_DEVICE_ID = "GETTER_DEVICE_ID";
export var UPDATE_SERVICE_LIST = "UPDATE_SERVICE_LIST";
export var GETTER_SERVICE_LIST = "GETTER_SERVICE_LIST";
export var REQUEST_SETTING_DATA = "REQUEST_SETTING_DATA";
export var REQUEST_NATIVE_SETTING = "REQUEST_NATIVE_SETTING";
export var GET_LAUNCH_CONFIG = "GET_LAUNCH_CONFIG";
export var UPDATE_LAUNCH_CONFIG = "UPDATE_LAUNCH_CONFIG";
export var GETTER_LAUNCH_CONFIG = "GETTER_LAUNCH_CONFIG";
export var UPDATE_LOCAL_FILES = "UPDATE_LOCAL_FILES";
export var GETTER_SETTING_DATA = "GETTER_SETTING_DATA";
export var GETTER_MAIN_FUNCTION_LIST = "GETTER_MAIN_FUNCTION_LIST";
export var SHOW_TOAST = "SHOW_TOAST";
export var GETTER_TOAST = "GETTER_TOAST";
export var HIDE_TOAST = "HIDE_TOAST";
export var SHOW_NETWORK_TOAST = "SHOW_NETWORK_TOAST";
export var SHOW_FACE_TOAST = "SHOW_FACE_TOAST";
export var GETTER_OFFER_MAP = "GETTER_OFFER_MAP";
export var GETTER_PRICE_MAP = "GETTER_PRICE_MAP";
export var GETTER_VIP_OFFER_LIST = "GETTER_VIP_OFFER_LIST";
export var PAY_VIP = "PAY_VIP";
export var UPDATE_MORNING_NOOTICE_STATUS = "UPDATE_MORNING_NOOTICE_STATUS";
export var GETTER_MORNING_NOOTICE_STATUS = "GETTER_MORNING_NOOTICE_STATUS";
export var UPDATE_EVNING_NOOTICE_STATUS = "UPDATE_EVNING_NOOTICE_STATUS";
export var GETTER_EVNING_NOOTICE_STATUS = "GETTER_EVNING_NOOTICE_STATUS";
export var PALMISTRY_PHOTO = "PALMISTRY_PHOTO";
export var PALMISTRY = "PALMISTRY";
export var LOVE_COMSULTANT = "LOVE_COMSULTANT";
export var WEALTH_FORE_CAST = "WEALTH_FORE_CAST";
export var FETCH_PALM_PRINT_DATA = "FETCH_PALM_PRINT_DATA";
export var GETTER_PALM_PRINT_DATA = "GETTER_PALM_PRINT_DATA";
export var FETCH_FACE_READING_DATA = "FETCH_FACE_READING_DATA";
export var GETTER_FACE_READING_DATA = "GETTER_FACE_READING_DATA";
export var UPDATE_DAILY_PLAMISTRY_DATA = "UPDATE_DAILY_PLAMISTRY_DATA";
export var GETTER_DAILY_PLAMISTRY_DATA = "GETTER_DAILY_PLAMISTRY_DATA";
export var UPDATE_LOADING_STATUS = "UPDATE_LOADING_STATUS";
export var GETTER_LOADING_STATUS = "GETTER_LOADING_STATUS";
export var UPDATE_RESULT_BY_NAME = "UPDATE_RESULT_BY_NAME";
export var UPDATE_FUNCTION_LIST = "UPDATE_FUNCTION_LIST";
export var RESET_RESULT_BY_NAME = "RESET_RESULT_BY_NAME";
export var GETTER_TEMP_RESULT_BY_NAME = "GETTER_TEMP_RESULT_BY_NAME";
export var ASYNC_GET_FUTURE_BABY_RESULT = "ASYNC_GET_FUTURE_BABY_RESULT";
export var SYNC_GET_FUTURE_BABY_RESULT = "SYNC_GET_FUTURE_BABY_RESULT";
export var UPDATE_USER_MSG = "UPDATE_USER_MSG";
export var GETTER_USER_MSG = "GETTER_USER_MSG";
export var UPDATE_OFFER_ID = "UPDATE_OFFER_ID";
export var GETTER_OFFER_ID = "GETTER_OFFER_ID";
export var GETTER_DELAY_SINGLE_PAGE_TIME = "GETTER_DELAY_SINGLE_PAGE_TIME";
export var GETTER_VIP_PLAN_BY_SOURCE = "GETTER_VIP_PLAN_BY_SOURCE";
export var SHOW_VIP_TOAST = "SHOW_VIP_TOAST";
export var GET_CELE_RESULT = "GET_CELE_RESULT";
export var GET_CELE_PHOTOS_RESULT = "GET_CELE_PHOTOS_RESULT";
export var CELE_PHOTOS = "CELE_PHOTOS";
export var GETTER_VIP_RELATE_DATA = "GETTER_VIP_RELATE_DATA";
export var UPDATE_VIP_PARAMS = "UPDATE_VIP_PARAMS";
export var BEAUTY_CONTEST_IOSNEW = "BEAUTY_CONTEST_IOSNEW";
export var UPDATE_READING_LIST = "UPDATE_READING_LIST";
export var GETTER_READING_LIST = "GETTER_READING_LIST";
export var UPDATE_VIP_ROUTER_DATA = "UPDATE_VIP_ROUTER_DATA";
export var GETTER_VIP_ROUTER_DATA = "UPDATE_VIP_ROUTER_DATA";
export var UPDATE_CARD_CLICK_TIMES = "UPDATE_CARD_CLICK_TIMES";
export var GETTER_CARD_CLICK_TIMES = "GETTER_CARD_CLICK_TIMES";